import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, ClipPath, G, Defs, Rect } from "react-native-svg";

import appStyles from "../../../../appStyles";

export default function IntegrationsIconWhite(props) {
  return (
    <TouchableOpacity style={[appStyles.iconContainer, props.style]} {...props}>
      <Svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G clipPath="url(#clip0_integration_white)">
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3116 14.8889C17.6709 14.5413 17.6804 13.9683 17.3328 13.609C16.9853 13.2498 16.4122 13.2403 16.053 13.5878L12.943 16.5965C12.7608 16.7727 12.6608 17.0173 12.6675 17.2706C12.6741 17.524 12.7866 17.763 12.9777 17.9295L16.2652 20.7933C16.6421 21.1217 17.2138 21.0823 17.5422 20.7054C17.8705 20.3285 17.8312 19.7567 17.4542 19.4284L15.769 17.9602H26.4286C26.9285 17.9602 27.3337 17.555 27.3337 17.0551C27.3337 16.5552 26.9285 16.15 26.4286 16.15H16.0081L17.3116 14.8889ZM12.667 22.6271C12.667 22.1272 13.0722 21.7219 13.5721 21.7219H24.2318L22.5466 20.2539C22.1697 19.9255 22.1303 19.3538 22.4587 18.9768C22.787 18.5999 23.3587 18.5606 23.7357 18.8889L27.0231 21.7527C27.2142 21.9192 27.3268 22.1582 27.3334 22.4116C27.34 22.665 27.24 22.9095 27.0579 23.0857L23.9479 26.0944C23.5886 26.442 23.0156 26.4325 22.668 26.0732C22.3204 25.7139 22.3299 25.1409 22.6892 24.7933L23.9928 23.5322H13.5721C13.0722 23.5322 12.667 23.1269 12.667 22.6271Z"
            fill="#FFF"
          />
        </G>
        <Defs>
          <ClipPath id="clip0_integration_white">
            <Rect
              width="14.6667"
              height="13.0157"
              fill="#FFF"
              transform="translate(12.667 13.3333)"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
